/** The starting document: an invented person, written to show every part of the format. */
export const SAMPLE = `# Rowan Ellis

**Title:** Mobile Engineer
**Location:** Glasgow, UK
**Email:** rowan.ellis@example.com
**Phone:** +44 7700 900123
**LinkedIn:** linkedin.com/in/example
**GitHub:** github.com/example

## Experience

### Fernhill Gardens – Glasgow, UK | Jun 2021–Present
*Garden centre chain with a plant-care app for its loyalty members.*

**Lead Mobile Engineer** | Mar 2024–Present
- Rebuilt the plant identification screen so it works offline in greenhouses with no signal.
- Cut the app's download size in half by loading plant photos only when they're opened.
- Ran fortnightly usability sessions with customers in store.

**Mobile Engineer** | Jun 2021–Feb 2024
- Added watering reminders, now the app's most used feature.
- Made every screen work with VoiceOver and large text sizes.

### Paper Lantern Games – Edinburgh, UK | Sep 2018–May 2021
*Small studio making puzzle games for phones.*

**Developer** | Sep 2018–May 2021
- Wrote the level editor the designers used for three released games.
- Fixed dropped frames on older phones by redrawing only the parts of the board that changed.

## Projects

### Night Sky | github.com/example/night-sky
*Open-source star chart that follows your phone's compass.*
- Drew the chart from a public star catalogue and kept it smooth while the phone moves.

## Skills

- **Languages:** Swift, TypeScript, SQL
- **Frameworks:** SwiftUI, React Native
- **Tools:** Xcode, Figma, Firebase

## Education

- BSc Interaction Design, Example University, 2018
`;
